import React, {Fragment, useState} from 'react';
import {GUTTER_SM, MODAL_WIDTH_LG, MODAL_WIDTH_XL} from "../../../styles/constants";
import EnhancedModal from '../../../components/enhanced-modal';
import {compose} from "redux";
import {connect} from "react-redux";
import {translate} from 'react-i18next';
import {
  changeDataflowsDetailDataflow,
  closeDataflowsDetailVirtualDataflowDataflowsModal,
  hideDataflowsDetail,
  hideDataflowsDetailDsds,
  hideDataflowsDetailLayoutAnnotationsForm,
  openDataflowsDetailVirtualDataflowDataflowsModal,
  pingDataflowsDetailVirtualDataflowEndpoint,
  readDataflowsDetailAgencies,
  readDataflowsDetailDataflow,
  readDataflowsDetailDsdForLayoutAnnotations,
  readDataflowsDetailDsds,
  readDataflowsDetailLayoutAnnotationsItemsPage,
  readDataflowsDetailVirtualDataflowDataflows,
  resetDataflowsDetailLayoutAnnotationsForm,
  resetDataflowsDetailLayoutAnnotationsItemsPage,
  setDataflowsDetailDsd,
  setDataflowsDetailVirtualDataflowDataflow,
  setDataflowsDetailVirtualDataflowEndpoint,
  showDataflowsDataflowClone,
  showDataflowsDataflowDownload,
  showDataflowsDataflowExport,
  showDataflowsDetailDsds,
  showDataflowsDetailLayoutAnnotationsForm,
  submitDataflowsDetailDataflowCreate,
  submitDataflowsDetailDataflowUpdate,
  submitDataflowsDetailLayoutAnnotationsForm,
  unsetDataflowsDetailDsd,
  unsetDataflowsDetailVirtualDataflowDataflow
} from "./actions";
import {Alert, Button, Col, Modal, Row, Tabs} from "antd";
import ArtefactForm, {
  ARTEFACT_FORM_MODE_CREATE,
  ARTEFACT_FORM_MODE_EDIT,
  ARTEFACT_FORM_MODE_READ
} from '../../../components/artefact-form';
import Call from "../../../hocs/call";
import Selector from "../../../components/selector";
import {isArtefactValid} from "../../../utils/artefactValidators";
import {getStringFromArtefactTriplet} from "../../../utils/sdmxJson";
import ReduxdsdDetailModal from "../../../redux-components/redux-dsd-detail-modal";
import {MM_DATAFLOWS_DSD_DETAIL_PREFIX, MM_DATAFLOWS_SELECTED_DSD_DETAIL_PREFIX} from "./reducer";
import {reuseAction} from "../../../utils/reduxReuse";
import {showDsdDetail} from "../../../redux-components/redux-dsd-detail-modal/actions";
import ArtefactList from "../../../components/artefact-list";
import {DataLanguageConsumer} from "../../../contexts/DataLanguage";
import EndpointsDropdown from "../../../components/endpoints-dropdown";
import {AUTO_ANNOTATION_VIRTUAL_DATAFLOW_NODE_KEY} from "../../../utils/annotations";
import {DATAFLOW_TYPE_ONLY_FILE, DATAFLOW_TYPE_VIRTUAL} from "../../../utils/dataflow";

const mapStateToProps = state => ({
  nodes: state.config.nodes,
  nodeId: state.app.endpointId,
  appLanguage: state.app.language,
  isVisible: state.scenes.metaManager.dataflows.isDetailVisible,
  dataflowTriplet: state.scenes.metaManager.dataflows.dataflowTriplet,
  isDataflowValid: state.scenes.metaManager.dataflows.isDataflowValid,
  isAgenciesValid: state.scenes.metaManager.dataflows.isAgenciesValid,
  isDataflowGeneralTabDirty: state.scenes.metaManager.dataflows.isDataflowGeneralTabDirty,
  dataflow: state.scenes.metaManager.dataflows.dataflow,
  agencies: state.scenes.metaManager.dataflows.agencies,
  dsds: state.scenes.metaManager.dataflows.dsds,
  isDsdsListVisible: state.scenes.metaManager.dataflows.isDsdsListVisible,
  dsdDetail: state.scenes.metaManager.dataflows.dsdDetail,
  selectedDsdDetail: state.scenes.metaManager.dataflows.selectedDsdDetail,
  selectedDsdTriplet: state.scenes.metaManager.dataflows.selectedDsdTriplet,
  permissions: state.app.user.permissions,
  dsdForLayoutAnnotations: state.scenes.metaManager.dataflows.dsdForLayoutAnnotations,
  isLayoutAnnotationsFormVisible: state.scenes.metaManager.dataflows.isLayoutAnnotationsFormVisible,
  itemsPageForLayoutAnnotations: state.scenes.metaManager.dataflows.itemsPageForLayoutAnnotations,
  endpoints: state.config.nodes,
  endpointId: state.app.endpointId,
  isVirtualDFEndpointAvailable: state.scenes.metaManager.dataflows.isVirtualDFEndpointAvailable,
  isVirtualDFDataflowsModalOpen: state.scenes.metaManager.dataflows.isVirtualDFDataflowsModalOpen,
  virtualDFDataflows: state.scenes.metaManager.dataflows.virtualDFDataflows,
});

const mapDispatchToProps = dispatch => ({
  onDetailHide: () => dispatch(hideDataflowsDetail()),
  onDetailChange: fields => dispatch(changeDataflowsDetailDataflow(fields)),
  onDetailCreate: dataflow => dispatch(submitDataflowsDetailDataflowCreate(dataflow)),
  onDetailUpdate: (dataflow, keepModalOpen) => dispatch(submitDataflowsDetailDataflowUpdate(dataflow, keepModalOpen)),
  fetchDataflow: dataflowTriplet => dispatch(readDataflowsDetailDataflow(dataflowTriplet)),
  fetchAgencies: allowedAgencies => dispatch(readDataflowsDetailAgencies(allowedAgencies)),
  onDsdsShow: () => dispatch(showDataflowsDetailDsds()),
  onDsdsHide: () => dispatch(hideDataflowsDetailDsds()),
  fetchDsds: () => dispatch(readDataflowsDetailDsds()),
  onDsdDetailShow: dsdTriplet => dispatch(reuseAction(showDsdDetail(dsdTriplet), MM_DATAFLOWS_DSD_DETAIL_PREFIX)),
  onSelectedDsdDetailShow: dsdTriplet => dispatch(reuseAction(showDsdDetail(dsdTriplet), MM_DATAFLOWS_SELECTED_DSD_DETAIL_PREFIX)),
  onDsdSet: dsdTriplet => dispatch(setDataflowsDetailDsd(dsdTriplet)),
  onDsdUnset: () => dispatch(unsetDataflowsDetailDsd()),
  onDownloadShow: (dataflowTriplets, lang) => dispatch(showDataflowsDataflowDownload(dataflowTriplets, lang)),
  onCloneShow: artefactTriplet => dispatch(showDataflowsDataflowClone(artefactTriplet)),
  onExportShow: sourceTriplet => dispatch(showDataflowsDataflowExport(sourceTriplet)),
  fetchDsdForLayoutAnnotations: dsdTriplet => dispatch(readDataflowsDetailDsdForLayoutAnnotations(dsdTriplet)),
  onLayoutAnnotationsFormShow: () => dispatch(showDataflowsDetailLayoutAnnotationsForm()),
  onLayoutAnnotationsFormHide: () => dispatch(hideDataflowsDetailLayoutAnnotationsForm()),
  onLayoutAnnotationsFormSubmit: annotations => dispatch(submitDataflowsDetailLayoutAnnotationsForm(annotations)),
  onLayoutAnnotationsFormReset: () => dispatch(resetDataflowsDetailLayoutAnnotationsForm()),
  fetchItemsPageForLayoutAnnotations: ({
                                         codelistTriplet,
                                         language,
                                         pageNum,
                                         pageSize,
                                         searchText,
                                         filters,
                                         sortCol,
                                         sortByDesc
                                       }) => dispatch(readDataflowsDetailLayoutAnnotationsItemsPage({
    codelistTriplet,
    language,
    pageNum,
    pageSize,
    searchText,
    filters,
    sortCol,
    sortByDesc
  })),
  resetItemsPageForLayoutAnnotations: () => dispatch(resetDataflowsDetailLayoutAnnotationsItemsPage()),
  onVirtualDFEndpointSet: endpointId => dispatch(setDataflowsDetailVirtualDataflowEndpoint(endpointId)),
  onVirtualDFDataflowSet: dataflowTriplet => dispatch(setDataflowsDetailVirtualDataflowDataflow(dataflowTriplet)),
  onVirtualDFDataflowUnset: () => dispatch(unsetDataflowsDetailVirtualDataflowDataflow()),
  onVirtualDFEndpointPing: endpointId => dispatch(pingDataflowsDetailVirtualDataflowEndpoint(endpointId)),
  onVirtualDFDataflowsModalOpen: () => dispatch(openDataflowsDetailVirtualDataflowDataflowsModal()),
  onVirtualDFDataflowsModalClose: () => dispatch(closeDataflowsDetailVirtualDataflowDataflowsModal()),
  fetchVirtualDFDataflows: endpointId => dispatch(readDataflowsDetailVirtualDataflowDataflows(endpointId))
});

const selector = (t, onSelectedDsdDetailShow, selectedDsdTriplet, onDsdsShow, onDsdUnset, disabled) =>
  <Selector
    disabled={disabled}
    detailTitle={t('commons.artefact.tabs.general.dsd.selector.detail.title')}
    selectTitle={t('commons.artefact.tabs.general.dsd.selector.select.title')}
    resetTitle={t('commons.artefact.tabs.general.dsd.selector.reset.title')}
    onDetail={() => onSelectedDsdDetailShow(selectedDsdTriplet)}
    onSelect={onDsdsShow}
    onReset={onDsdUnset}
  />;

const DataflowsDetail = ({
                           t,
                           appLanguage,
                           isVisible,
                           dataflowTriplet,
                           isDataflowValid,
                           isAgenciesValid,
                           isDataflowGeneralTabDirty,
                           dataflow,
                           agencies,
                           onDetailHide,
                           onDetailChange,
                           onDetailCreate,
                           onDetailUpdate,
                           fetchDataflow,
                           fetchAgencies,
                           dsds,
                           isDsdsListVisible,
                           dsdDetail,
                           selectedDsdTriplet,
                           selectedDsdDetail,
                           onDsdsShow,
                           onDsdsHide,
                           fetchDsds,
                           onDsdDetailShow,
                           onSelectedDsdDetailShow,
                           onDsdSet,
                           onDsdUnset,
                           permissions,
                           endpoints,
                           endpointId,
                           isVirtualDFEndpointAvailable,
                           isVirtualDFDataflowsModalOpen,
                           virtualDFDataflows,
                           onVirtualDFEndpointSet,
                           onVirtualDFDataflowsModalOpen,
                           onVirtualDFDataflowsModalClose,
                           onVirtualDFDataflowSet,
                           onVirtualDFDataflowUnset,
                           onVirtualDFEndpointPing,
                           fetchVirtualDFDataflows,
                           onDownloadShow,
                           onCloneShow,
                           onExportShow,
                           fetchDsdForLayoutAnnotations,
                           dsdForLayoutAnnotations,
                           isLayoutAnnotationsFormVisible,
                           onLayoutAnnotationsFormShow,
                           onLayoutAnnotationsFormHide,
                           onLayoutAnnotationsFormSubmit,
                           onLayoutAnnotationsFormReset,
                           itemsPageForLayoutAnnotations,
                           fetchItemsPageForLayoutAnnotations,
                           resetItemsPageForLayoutAnnotations
                         }) => {

  const virtualDFEndpointIdAnnotType = endpoints.find(node => node.general.id === endpointId).annotations[AUTO_ANNOTATION_VIRTUAL_DATAFLOW_NODE_KEY];
  const virtualDFEndpointIdAnnot = dataflow
    ? (
      (dataflow.annotations || []).find(({type}) => type === virtualDFEndpointIdAnnotType) ||
      (dataflow.autoAnnotations || []).find(({type}) => type === virtualDFEndpointIdAnnotType)
    )
    : null
  const virtualDFEndpointId = virtualDFEndpointIdAnnot ? virtualDFEndpointIdAnnot.title : null;

  const userHasPermissionsToEdit = (
    permissions && dataflowTriplet &&
    permissions.agencies.filter(agency => agency === dataflowTriplet.agencyID).length > 0
  );

  const [tab, setTab] = useState("general");

  const VirtualDFNodeSelect =
    dataflow && dataflow.isExternalReference
      ? (
        <EndpointsDropdown
          disabled={dataflowTriplet}
          endpoints={endpoints.filter(ep => ep.general.id !== endpointId)}
          endpointId={virtualDFEndpointId}
          onEndpointSet={onVirtualDFEndpointSet}
          onNodePing={() => onVirtualDFEndpointPing(virtualDFEndpointId)}
          isEndpointAvailable={isVirtualDFEndpointAvailable}
          doNotGoHome
          canBeNull
          fullWidth
        />
      )
      : null;

  const VirtualDFDataflowSelector =
    !!dataflow && dataflow.isExternalReference
      ? (
        <Call cb={onVirtualDFEndpointPing} cbParam={virtualDFEndpointId}
              disabled={!virtualDFEndpointId || endpoints.find(ep => ep.general.id === virtualDFEndpointId) === undefined}>
          <Selector
            disabled={!!dataflowTriplet || !isVirtualDFEndpointAvailable || !virtualDFEndpointId}
            selectTitle={t("scenes.metaManager.dataflows.detail.virtualDFDataflowSelector.select.title")}
            resetTitle={t("scenes.metaManager.dataflows.detail.virtualDFDataflowSelector.reset.title")}
            onSelect={onVirtualDFDataflowsModalOpen}
            onReset={onVirtualDFDataflowUnset}
            value={
              dataflow.id && dataflow.agencyID && dataflow.version
                ? getStringFromArtefactTriplet({
                  id: dataflow.id,
                  agencyID: dataflow.agencyID,
                  version: dataflow.version
                })
                : null
            }
          />
          {virtualDFEndpointId && isVirtualDFEndpointAvailable && (
            <EnhancedModal
              visible={isVirtualDFDataflowsModalOpen}
              onCancel={onVirtualDFDataflowsModalClose}
              title={t('scenes.metaManager.dataflows.detail.virtualDFDataflowSelector.modal.title')}
              width={MODAL_WIDTH_LG}
              footer={<Button
                onClick={onVirtualDFDataflowsModalClose}>{t('commons.buttons.close.title')}</Button>}
            >
              <Call
                cb={fetchVirtualDFDataflows}
                cbParam={virtualDFEndpointId}
                disabled={!isVirtualDFDataflowsModalOpen}
              >
                {virtualDFDataflows &&
                virtualDFDataflows.find(({agencyID}) => !permissions.agencies.includes(agencyID)) && (
                  <Alert
                    type="warning"
                    showIcon
                    message={t('scenes.metaManager.dataflows.detail.virtualDFDataflowSelector.list.alert.someDataflowsAreDisabledForUnallowedAgency')}
                  />
                )}
                <ArtefactList
                  artefacts={virtualDFDataflows}
                  onRowClick={onVirtualDFDataflowSet}
                  getIsDisabledRow={({agencyID}) => !permissions.agencies.includes(agencyID)}
                />
              </Call>
            </EnhancedModal>
          )}
        </Call>
      )
      : null;

  return (
    <Call
      cb={fetchDataflow}
      cbParam={dataflowTriplet}
      disabled={isDataflowValid}
    >
      <Call
        cb={fetchAgencies}
        cbParam={permissions ? permissions.agencies : undefined}
        disabled={isAgenciesValid}
      >
        <EnhancedModal
          visible={isVisible}
          width={MODAL_WIDTH_XL}
          title={
            dataflowTriplet !== null
              ? (
                userHasPermissionsToEdit
                  ? t('scenes.metaManager.dataflows.detail.title.editMode.title', {triplet: dataflowTriplet})
                  : t('scenes.metaManager.dataflows.detail.title.viewMode.title', {triplet: dataflowTriplet})
              )
              : t('scenes.metaManager.dataflows.detail.title.createMode.title')
          }
          onCancel={onDetailHide}
          footer={
            <div>
              <Button onClick={onDetailHide}>{t('commons.buttons.close.title')}</Button>
              {dataflowTriplet === null || userHasPermissionsToEdit
                ? (
                  <Button
                    type="primary"
                    onClick={() => {
                      if (!isArtefactValid(dataflow) || (dataflow.isExternalReference && virtualDFEndpointId === null)) {
                        Modal.warning({
                          title: t('commons.alerts.invalidForm.title'),
                          content: t('commons.alerts.invalidForm.content')
                        });
                      } else {
                        if (dataflowTriplet !== null) {
                          onDetailUpdate(dataflow)
                        } else {
                          onDetailCreate(dataflow)
                        }
                      }
                    }}
                  >
                    {t("commons.buttons.save.title")}
                  </Button>
                )
                : null}
            </div>
          }
          withDataLanguageSelector
        >
          <DataLanguageConsumer>
            {dataLanguage => {
              const lang = dataLanguage || appLanguage;
              return dataflowTriplet
                ? (
                  <Fragment>
                    {permissions && !userHasPermissionsToEdit && (
                      <Alert
                        type="warning"
                        showIcon
                        message={t('commons.artefact.alerts.hasNotAgencyPermission')}
                      />
                    )}
                    <Row type="flex" gutter={GUTTER_SM} justify={"end"}>
                      <Col>
                        <Button
                          type="primary"
                          shape="circle"
                          icon="download"
                          size="small"
                          title={t('commons.artefact.buttons.download.title')}
                          onClick={() => onDownloadShow([dataflowTriplet], lang)}
                        />
                      </Col>
                      {permissions && (
                        <Col>
                          <Button
                            type="primary"
                            shape="circle"
                            icon="copy"
                            size="small"
                            title={t('commons.artefact.buttons.clone.title')}
                            onClick={() => {
                              if (dataflow.isExternalReference) {
                                Modal.error({title: t("scenes.metaManager.dataflows.errors.cannotCloneVirtualDF.title")});
                              } else {
                                onCloneShow(dataflowTriplet)
                              }
                            }}
                          />
                        </Col>
                      )}
                      <Col>
                        <Button
                          type="primary"
                          shape="circle"
                          icon="export"
                          size="small"
                          title={t('commons.artefact.buttons.export.title')}
                          onClick={() => onExportShow(dataflowTriplet)}
                        />
                      </Col>
                    </Row>
                    <Tabs
                      activeKey={tab}
                      onTabClick={
                        key => {
                          if (!isArtefactValid(dataflow) || (dataflow.isExternalReference && virtualDFEndpointId === null)) {
                            Modal.warning({
                              title: t('commons.alerts.invalidForm.title'),
                              content: t('commons.alerts.invalidForm.content')
                            });
                          } else {
                            setTab(key);
                            if (key === "categorisations") {
                              Modal.error({title: t('errors.notImplemented')});
                            }
                            if (isDataflowGeneralTabDirty) {
                              onDetailUpdate(dataflow, true)
                            }
                          }
                        }
                      }
                    >
                      <Tabs.TabPane
                        key="general"
                        tab={t('commons.artefact.tabs.general.title')}
                      >
                        {dataflow && (
                          <ArtefactForm
                            artefact={dataflow}
                            mode={userHasPermissionsToEdit ? ARTEFACT_FORM_MODE_EDIT : ARTEFACT_FORM_MODE_READ}
                            agencies={agencies}
                            onChange={onDetailChange}
                            DSDInput={
                              (
                                dataflow.dataflowType === DATAFLOW_TYPE_VIRTUAL
                                || dataflow.dataflowType === DATAFLOW_TYPE_ONLY_FILE
                              )
                                ? null
                                : selector(t, onSelectedDsdDetailShow, selectedDsdTriplet, onDsdsShow, onDsdUnset, true)
                            }
                            dsdDimensions={dsdForLayoutAnnotations && dsdForLayoutAnnotations.dimensions}
                            dsdAttributes={dsdForLayoutAnnotations && dsdForLayoutAnnotations.attributes}
                            isDataflow
                            isLayoutAnnotationsFormVisible={isLayoutAnnotationsFormVisible}
                            dataflow={dataflow}
                            dsdForLayoutAnnotations={dsdForLayoutAnnotations}
                            onLayoutAnnotationsFormShow={onLayoutAnnotationsFormShow}
                            onLayoutAnnotationsFormHide={onLayoutAnnotationsFormHide}
                            onLayoutAnnotationsFormSubmit={onLayoutAnnotationsFormSubmit}
                            onLayoutAnnotationsFormReset={onLayoutAnnotationsFormReset}
                            fetchDsdForLayoutAnnotations={fetchDsdForLayoutAnnotations}
                            itemsPageForLayoutAnnotations={itemsPageForLayoutAnnotations}
                            fetchItemsPageForLayoutAnnotations={fetchItemsPageForLayoutAnnotations}
                            resetItemsPageForLayoutAnnotations={resetItemsPageForLayoutAnnotations}
                            canBeSpecialDataflow
                            VirtualDFNodeInput={VirtualDFNodeSelect}
                            VirtualDFDataflowInput={VirtualDFDataflowSelector}
                          />
                        )}
                      </Tabs.TabPane>
                      <Tabs.TabPane
                        key="categorisations"
                        tab={t('commons.artefact.tabs.categorisations.title')}
                      >
                      </Tabs.TabPane>
                    </Tabs>
                  </Fragment>
                )
                : (
                  <ArtefactForm
                    artefact={dataflow}
                    mode={ARTEFACT_FORM_MODE_CREATE}
                    agencies={agencies}
                    onChange={onDetailChange}
                    DSDInput={
                      (
                        dataflow.dataflowType === DATAFLOW_TYPE_VIRTUAL
                        || dataflow.dataflowType === DATAFLOW_TYPE_ONLY_FILE
                      )
                        ? null
                        : selector(t, onSelectedDsdDetailShow, selectedDsdTriplet, onDsdsShow, onDsdUnset)
                    }
                    dsdDimensions={dsdForLayoutAnnotations && dsdForLayoutAnnotations.dimensions}
                    dsdAttributes={dsdForLayoutAnnotations && dsdForLayoutAnnotations.attributes}
                    isDataflow
                    isLayoutAnnotationsFormVisible={isLayoutAnnotationsFormVisible}
                    dataflow={dataflow}
                    dsdForLayoutAnnotations={dsdForLayoutAnnotations}
                    onLayoutAnnotationsFormShow={onLayoutAnnotationsFormShow}
                    onLayoutAnnotationsFormHide={onLayoutAnnotationsFormHide}
                    onLayoutAnnotationsFormSubmit={onLayoutAnnotationsFormSubmit}
                    onLayoutAnnotationsFormReset={onLayoutAnnotationsFormReset}
                    fetchDsdForLayoutAnnotations={fetchDsdForLayoutAnnotations}
                    itemsPageForLayoutAnnotations={itemsPageForLayoutAnnotations}
                    fetchItemsPageForLayoutAnnotations={fetchItemsPageForLayoutAnnotations}
                    resetItemsPageForLayoutAnnotations={resetItemsPageForLayoutAnnotations}
                    canBeSpecialDataflow
                    VirtualDFNodeInput={VirtualDFNodeSelect}
                    VirtualDFDataflowInput={VirtualDFDataflowSelector}
                  />
                )
            }}
          </DataLanguageConsumer>
        </EnhancedModal>
        <EnhancedModal
          visible={isDsdsListVisible}
          onCancel={onDsdsHide}
          title={t('commons.artefact.tabs.general.dsd.modals.dsdList.title')}
          width={MODAL_WIDTH_LG}
          footer={<Button onClick={onDsdsHide}>{t('commons.buttons.close.title')}</Button>}
        >
          <Call cb={fetchDsds}>
            <ArtefactList
              artefacts={dsds}
              onDetailShow={onDsdDetailShow}
              onRowClick={onDsdSet}
              getIsDisabledRow={({isFinal}) => !isFinal}
            />
          </Call>
        </EnhancedModal>
        <ReduxdsdDetailModal
          instancePrefix={MM_DATAFLOWS_DSD_DETAIL_PREFIX}
          instanceState={dsdDetail}
        />
        <ReduxdsdDetailModal
          instancePrefix={MM_DATAFLOWS_SELECTED_DSD_DETAIL_PREFIX}
          instanceState={selectedDsdDetail}
        />
      </Call>
    </Call>
  );
};

export default compose(
  translate(),
  connect(mapStateToProps, mapDispatchToProps),
)(DataflowsDetail);



// WEBPACK FOOTER //
// ./src/scenes/meta-manager/dataflows/Detail.jsx